if (!customElements.get('accordion-content')) {
  class AccordionContent extends HTMLElement {
    static observedAttributes = ["open"];

    constructor() {
      super();

      this.enabled = true;
      this.desktop = window.matchMedia('(min-width: 1024px)').matches;

      this.open = this.getAttribute('open') == 'true';
      this.exclusive = this.getAttribute('exclusive') == 'true';
      this.enabledDesktop = this.getAttribute('enabled-desktop') != 'false';
      this.enabledMobile = this.getAttribute('enabled-mobile') != 'false';

      this.elToggle = this.querySelector('[data-toggle]');
      this.elContent = this.querySelector('[data-content]');
      this.elSection = this.closest('[data-accordion-section]');

      this.elToggle.addEventListener('click', this.toggleAccordion.bind(this));

      if (!this.enabledDesktop || !this.enabledMobile) {
        setTimeout(() => this.enableDisable(), 500);
        window.addEventListener('resize', () => {
          let isDesktop = window.matchMedia('(min-width: 1024px)').matches;
          isDesktop != this.desktop && this.enableDisable();
        });
      }

      this.setWidths();
      window.addEventListener('resize', this.setWidths.bind(this));
    }


    attributeChangedCallback(name, oldValue, newValue) {
      if (newValue == "true") {
        this.open = true;
        this.classList.add('visible');
        setTimeout(() => {
          this.classList.add('open');
          this.elToggle.setAttribute('aria-expanded', true);
          this.elContent.setAttribute('aria-hidden', false);
          if (this.enabled && this.exclusive) {
            this.elSection.querySelectorAll('accordion-content').forEach(el => {
              el !== this && el.setAttribute('open', false)
            });
          }
        }, 50);
      } else {
        this.open = false;
        this.classList.remove('open');
        this.elToggle.setAttribute('aria-expanded', false);
        this.elContent.setAttribute('aria-hidden', true);
        setTimeout(() => {
          this.classList.remove('visible');
        }, 300)
      }
    }

    toggleAccordion() {
      this.setAttribute('open', !this.open);
    }

    setWidths() {
      this.style.setProperty('--toggle-width', `${this.elToggle.clientWidth}px`);
      this.style.setProperty('--content-width', `${this.elContent.children[0].clientWidth}px`);
    }

    enableDisable() {
      let isDesktop = window.matchMedia('(min-width: 1024px)').matches;
      this.desktop = isDesktop;

      let shouldDisable = this.desktop ? !this.enabledDesktop : !this.enabledMobile;
      shouldDisable ? this.disable() : this.enable();
    }

    disable() {
      this.enabled = false;
      this.elToggle.disabled = true;
      this.setAttribute('open', true);
    }

    enable() {
      this.enabled = true;
      this.elToggle.disabled = false;
      this.setAttribute('open', false);
    }
  }
  customElements.define('accordion-content', AccordionContent);
}